import { immerable } from '@utils';
import { EdgeLayout } from './EdgeLayout';
import { NodeLayout } from './NodeLayout';

export class DocLayout {
  [immerable] = true;

  nodes = new Map<string, NodeLayout>();
  edges = new Map<string, EdgeLayout>();
}
